import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-content-collection-sections-select',
    templateUrl: './content-collection-sections-select.component.html',
    styleUrls: ['./content-collection-sections-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentCollectionSectionsSelectComponent implements OnInit {
    @Input() accessForm: FormGroup;
    @Input() referenceFilter: string;
    @Input() defaultSorting: string;
    @Input() params: { property: string; items: any[] }[];
    constructor() {}

    ngOnInit(): void {}
}
